import Month from "../entities/month";

const EdazStartMonth = 11;
const EdazStartYear = 2020;

export default class EdazLivingMonthsRepository {
  private static getLimitDate(useCurrentMonth = false) {
    const limit = new Date();
    limit.setDate(1);

    if (!useCurrentMonth) {
      limit.setMonth(limit.getMonth() - 1);
    }

    return limit;
  }

  createMonths(addCurrentMonth = false) {
    let yearCurrent = EdazStartYear;
    let monthCurrent = EdazStartMonth - 1;

    const limit = EdazLivingMonthsRepository.getLimitDate(addCurrentMonth);
    const yearLimit = limit.getFullYear();
    const monthLimit = limit.getMonth() + 1;

    const months: Month[] = [];

    while (yearCurrent !== yearLimit || monthCurrent !== monthLimit) {
      monthCurrent++;

      if (monthCurrent > 12) {
        monthCurrent = 1;
        yearCurrent++;
      }

      const month = new Month();
      month.month = monthCurrent;
      month.year = yearCurrent;

      months.push(month);
    }

    return months.reverse();
  }

  checkMonthsArrayValid(months: Month[]) {
    const limit = EdazLivingMonthsRepository.getLimitDate();
    if (!months[0]) {
      return false;
    }
    return months[0].month === limit.getMonth() + 1;
  }
}
